// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"input__input___2XeYb","isLarge":"input__isLarge___iwNPe","outlineNone":"input__outlineNone___15aOX","isSmall":"input__isSmall___2cT3O","copyToClipboard":"input__copyToClipboard___GhatR"};
    if(module.hot) {
      // 1778083490149
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  